<template>
  <v-data-table
    :headers="headers"
    :items="itemMaq"
    item-key="key"
    sort-by="Articulo"
    group-by="CodSeccion"
    class="elevation-1"
    show-group-by
    hide-default-footer
    disable-pagination
    
  >
    <template v-slot:[`item.Precio`]="{ item }">
      {{
        dataUser.VerPrecios[tipoMoneda] === true && !visiblePrecio({articulo: item,usuario: dataUser, arrcat:[1018, 1014], arrsubcat:[30,40]})
          ? simboloMoneda[tipoMoneda]
          : ""
      }}
      {{ dataUser.VerPrecios[tipoMoneda] && !visiblePrecio({articulo: item,usuario: dataUser, arrcat:[1018, 1014], arrsubcat:[30,40]}) ? item.Precio[tipoMoneda] : "" }}
    </template>
    <template v-slot:[`item.Disponible`]="{ item }">
      {{ dataUser.IndAutenticado ? item.Disponible : "" }}
    </template>
    <template v-slot:[`item.Articulo`]="{ item }">
      <span @click="articuloRoute(item.Articulo)" style="cursor: pointer">
        {{ item.Articulo }}
      </span>
    </template>
    <template
      v-slot:[`group.header`]="{ items, group, headers, toggle, isOpen }"
    >
      <td :colspan="headers.length">
        <v-btn @click="toggle" x-small icon :ref="group">
          <v-icon v-if="isOpen">mdi-minus</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
        <span style="color: #4d6572" class="mx-6 font-weight-bold">
          {{
            items
              .filter((x) => x.CodSeccion === group)
              .map((x) => x.NombreSec)[0]
          }}
        </span>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import {visiblePrecio} from "../static/funciones"
import { mapState } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "Codigo",
          value: "Articulo",
          align: "left",
          groupable: false,
          sortable: false,
          divider: true,
          width: "15%",
        },
        {
          text: "Nombre",
          align: "start",
          value: "NombreArt",
          groupable: false,
          width: "50%",
          sortable: false,
          divider: true,
        },
        {
          width: "10%",
          text: "Usa",
          value: "Cantidad",
          align: "center",
          groupable: false,
          sortable: false,
          divider: true,
        },
        {
          text: "Stock",
          width: "10%",
          value: "Disponible",
          align: "right",
          groupable: false,
          sortable: false,
          divider: true,
        },
        {
          text: "Precio",
          value: "Precio",
          align: "right",
          groupable: false,
          sortable: false,
          divider: true,
        },
        /* {
          text: "",
          class: "primary--text text--darken-2 body-2 font-weight-bold",
          value: "actions",
          sortable: false,
          width: "10%",
          align: "center",
          groupable: false,
        }, */
      ],
    };
  },
  methods: {
    articuloRoute(codart) {
      window.scrollTo(0, 0);
      if (codart != this.codArticulo)
        return this.$router.push("/articulo/" + codart);
    },
    visiblePrecio
  },
  computed: {
    ...mapState([
      "MaquinaRep",
      "tipoMoneda",
      "simboloMoneda",
      "dataUser",
      "Cliente",
    ]),
    codArticulo: {
      get: function () {
        return this.$route.params.codart;
      },
    },
    itemMaq() {
      if (Object.entries(this.MaquinaRep).length !== 0)
        return this.MaquinaRep.map((item, key) => ({ ...item, key }));
    },
  },
};
</script>

<style></style>
